import {
  FETCH_PAGES_REQUEST,
  FETCH_PAGES_SUCCESS,
  FETCH_PAGES_FAILURE,
  DISMISS_ERROR,
} from '../actions/pages'

const INITIAL_STATE = {
  isReady: false,
  isPageReady: false,
  hasError: false,
  errorMessage: '',
  pages: [],
  pagesById: {},
}

const pagesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_PAGES_REQUEST:
      return {
        ...state,
        isReady: false,
        hasError: false,
        errorMessage: '',
      }
    case FETCH_PAGES_SUCCESS:
      let pages = []
      let pagesById = {}
      action.payload.pages.forEach(page => {
        pagesById[page.id] = page
        pages.push(page.id)
      })
      return {
        ...state,
        isReady: true,
        hasError: false,
        errorMessage: '',
        pages: pages,
        pagesById: pagesById,
      }
    case FETCH_PAGES_FAILURE:
      return {
        ...state,
        isReady: true,
        hasError: true,
        errorMessage:
          action.payload instanceof Error && action.payload.message !== ''
            ? action.payload.message
            : 'An error occurred while trying to load the page',
      }
    case DISMISS_ERROR:
      return {
        ...state,
        isReady: true,
        hasError: false,
        errorMessage: '',
      }
    default:
      return state
  }
}

export default pagesReducer
